import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';

import { PickId } from '../../../../../core/picks/pick-id';
import { BetslipOverAskActions } from '../../../actions';

@Component({
    selector: 'bs-digital-over-ask-bet-remove',
    template: `
        <span
            class="betslip-over-ask-pick__remove"
            [class.theme-ex]="!isRemoved"
            [class.betslip-over-ask-pick__remove--undo]="isRemoved"
            (click)="onClick()">
            <ng-container *ngIf="isRemoved">{{ messages.undo }}</ng-container>
        </span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipOverAskBetRemoveComponent {
    @Input() pickId: PickId;
    @Input() isRemoved: boolean;

    readonly messages: {
        undo: string;
    };

    constructor(
        private store: Store,
        siteCore: Sitecore,
    ) {
        this.messages = {
            undo: siteCore.betslip.editBet.undo, // Take undo from edit bet there the logic is the same.
        };
    }

    onClick(): void {
        this.store.dispatch(BetslipOverAskActions.toggleRemoveBet({ pickId: this.pickId.toString() }));
    }
}
